import angular from 'angular';
import uiRouter from 'angular-ui-router';
import perDiemRatesComponent from './per-diem-rates.component';

let perDiemRatesModule = angular.module('perDiemRates', [
  uiRouter,
])

.config(($stateProvider) => {
  'ngInject';

  $stateProvider.state('admin.per-diem-rates', {
    parent: 'admin',
    url: '/settings/per-diem-rates',
    onEnter: function($state) {
      'ngInject';
      $state.go('admin.settings');
    }
  });
})

.component('perDiemRates', perDiemRatesComponent);

export default perDiemRatesModule;



// WEBPACK FOOTER //
// ./client/pages/admin/per-diem-rates/per-diem-rates.js